// extracted by mini-css-extract-plugin
export default {"inputWrapper":"styles_inputWrapper__5BP2V","input":"styles_input__axFuC"};